import React, { useEffect } from 'react';

// Hooks
import { useToast } from '../../../hooks/useToast';

// Components
import Spinner from '../Spinner/Spinner';

const ErrorSpinnerWrapper: React.FC<{
    children?: React.ReactNode,
    error: string | null,
    loading: boolean,
    sizeSpinner?: number
}> = ({ children, error, loading, sizeSpinner }) => {

    const { error: errorToast } = useToast();

    useEffect(() => {
        if (error) errorToast(error);
    }, [error, errorToast]);

    return (<>
        {loading ?
            <Spinner size={sizeSpinner}/>
            :
            children
        }
    </>);
};

export default ErrorSpinnerWrapper;